export const getSessionUser = () => ({
    email: sessionStorage.getItem("userEmail"),
    fullName: sessionStorage.getItem("userFullName"),
    compName: sessionStorage.getItem("compName"),

 
  });
  